var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C6 2.44772 6.44772 2 7 2H9C9.55228 2 10 2.44772 10 3H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H4.5C4.22386 4 4 3.77614 4 3.5C4 3.22386 4.22386 3 4.5 3H6ZM4.26918 5H11.7308C11.8761 5 11.9908 5.12352 11.9801 5.26847L11.4019 13.0739C11.3632 13.5961 10.9283 14 10.4046 14H5.59531C5.07168 14 4.63672 13.5961 4.59804 13.0739L4.01986 5.26847C4.00912 5.12352 4.12383 5 4.26918 5ZM6.25242 12.4076C6.27649 12.6827 6.519 12.8862 6.79409 12.8622C7.06918 12.8381 7.27268 12.5956 7.24861 12.3205L6.74747 6.59236C6.7234 6.31727 6.48088 6.11377 6.20579 6.13784C5.9307 6.16191 5.72721 6.40442 5.75127 6.67951L6.25242 12.4076ZM9.20584 12.8622C8.93074 12.8381 8.72725 12.5956 8.75132 12.3205L9.25246 6.59237C9.27653 6.31728 9.51905 6.11378 9.79414 6.13785C10.0692 6.16192 10.2727 6.40444 10.2487 6.67953L9.74751 12.4076C9.72344 12.6827 9.48093 12.8862 9.20584 12.8622Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.76490aed2ccf54c30650e4d34b51cd2d.svg";
export { ForwardRef as ReactComponent };